import { render, staticRenderFns } from "./UpgradeSummary.vue?vue&type=template&id=7d35a447"
import script from "./UpgradeSummary.vue?vue&type=script&lang=js"
export * from "./UpgradeSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports